import { useEnv } from "@/core/env";
import { useFeatureFlagContext } from "./feature-flag-context";
import { FEATURE_FLAG_NAMES } from "./feature-flag-name";

export const useFeatureFlag = (
  flagName: (typeof FEATURE_FLAG_NAMES)[keyof typeof FEATURE_FLAG_NAMES],
) => {
  const { appEnv } = useEnv();
  const { featureFlags, isLoading, isError } = useFeatureFlagContext();

  return {
    enabled: featureFlags?.[flagName]?.enabled ?? appEnv === "development", // default to true running against local backend
    isLoading,
    isError,
  };
};
